import React, { useContext, useEffect, useState } from 'react';
import { MasterBannerContext } from '../../../contexts/MasterBannerContext';
import Divider from '@mui/material/Divider';
import './index.css';
import useLocalStorage from '../../../hooks/useLocalStorage';


export const BannerRules = () => {
  const { master } = useContext(MasterBannerContext);
	const [rules, setRules] = useState([])

	const [collapsedFormatDiv, setCollapsedFormatDiv] = useState(true);
  const [ userLocalStorage, setUserLocalStorage] = useLocalStorage('@login-mastermotion/user', null);



	const handleCollapseFormat = () => {
		setCollapsedFormatDiv(!collapsedFormatDiv)
	};

	useEffect(()=>{	
		defineBannerRules()
	},[])

	
	const checkKeyWord = (keyWord) => {
		let inputKeyWords = keyWord.includes('vivo') || keyWord.includes('natal');
		if(inputKeyWords === true ){ return true;}else{ return false;}
		}
		
		const rule = {
			vivo: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form vivooooooo',
			natal: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form natalllllllll'
		}
		
		function defineBannerRules(){
			const userEmailDomain = userLocalStorage !== null || undefined ? userLocalStorage.email.split('@') : '';
			// const userEmailDomain = 'user@pointmedia.com.br'.split('@')
			const domains = 'pointmedia.com.brr'

			if (userEmailDomain && userEmailDomain[1].trim().toLowerCase() === domains){

				let psdKeyWords = master.psd.toLowerCase().slice(0, -4).split('_' || '-')
				let arrRules = []
				for(let i = 0; i < psdKeyWords.length; i++){	
					let check = checkKeyWord(psdKeyWords[i])
					if(check === true){
						arrRules.push({name: psdKeyWords[i], rule: rule[psdKeyWords[i]]});
					}
				}
				setRules(arrRules)
			}
			else return
	}




	return (

		<>
		{/* NOTIFICAÇÕES DESATIVADO */}
		{/* <div style={{margin: '12px'}}>
			<div className='propertiesTitleAndArrow'>
				<span style={{color: '#222222', fontWeight: 'bold', fontSize: '16px', margin: '0 0 -5px 4px'}}> <span className='circle' style={{ display: rules.length > 0 ? '' : 'none'}}>.</span>Notificações
				</span>
				{collapsedFormatDiv ? 
					<img src="assets/arrownew.png" className="stepNumberArrowUp" onClick={handleCollapseFormat} style={{transform: "rotate(180deg)", padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: rules.length > 0 ? '18px -3px 0 0' : '10px -3px 0 0'}}/> :
					<img src="assets/arrownew.png" className="stepNumberArrowUp" onClick={handleCollapseFormat} style={{padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: rules.length > 0 ? '18px -3px 0 0' : '10px -3px 0 0' }}/>
        }
			</div>
			<Divider className='propertiesDividerTitle'/>
		{
			!collapsedFormatDiv ? 
			<>
							{rules.length >= 1 ?
							<div style={{margin: '2px'}}>
							{rules.map((item, index)=>
								<span className='notification'>
								<b>{item.name}</b>
								<br />
								{item.rule}
								</span>
								)}
								</div>
								:
								<div className="without-Notification">
									<p>Sem notificações</p>
								</div>
							}
						<div className='propertiesContent'>


							</div>
						</>
			
			: <div></div> }
		</div> */}
			</>
	)
}

